/**
 * 時間格式化工具
 */

/**
 * 格式化時間戳為繁體中文格式
 * @param {string|Date} timestamp - ISO 時間戳字符串或 Date 對象
 * @returns {string} 格式化後的時間字符串（例如：2026/2/13 18:30）
 */
export const formatTimestamp = (timestamp) => {
  try {
    const date = new Date(timestamp);
    // 檢查日期是否有效
    if (isNaN(date.getTime())) {
      return 'Invalid Date';
    }
    return new Intl.DateTimeFormat('zh-TW', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: false
    }).format(date);
  } catch (error) {
    return 'Invalid Date';
  }
};

export default formatTimestamp;
